import React from 'react'

export default function Loader() {
    return (
        <>
            <div className="flex items-center justify-center space-x-2">
                <div className="w-4 h-4 rounded-full animate-pulse dark:bg-yellow-400"></div>
                <div className="w-4 h-4 rounded-full animate-pulse dark:bg-yellow-400"></div>
                <div className="w-4 h-4 rounded-full animate-pulse dark:bg-yellow-400"></div>
            </div>
        </>
    )
}
